export default __webpack_public_path__ + "static/media/alan-seal-horizontal-color.e753ad6b.png";